
import {api_host} from '../common/constants'
export const insertSubmit = (day, nodes, objective,step, sla, slaError, perf, error, out, sample,prom, date ) => 
    fetch(api_host+`/reporte/especial/submitDayMovistar/?dia=${day}&prom=${prom}&objetivo_id=${objective}&nodos=${nodes}&sla_ok=${sla}&sla_error=${slaError}&perf=${perf}&error=${error}&fuera=${out}&paso=${step}&muestra=${sample}&token=07374CEAC2EAEF2EB3441BA0C433F9834E6CF6E3&date=${date}`)
.then(response => response.json())

export const insertSubmitMonth = (month, objective,step, sla, perf, error, out,prom ) => 
    fetch(api_host+`/reporte/especial/updateMonthMovistar/?mes=${month}&prom=${prom}&idObjetivo=${objective}&sla=${sla}&perf=${perf}&error=${error}&fuera=${out}&paso=${step}&token=07374CEAC2EAEF2EB3441BA0C433F9834E6CF6E3`)
.then(response => response.json())



// WEBPACK FOOTER //
// ./src/services/InsertSubmit.jsx